export default function progression(state = '', action){
  if (action.type === 'progression') {
    var copyProgression = JSON.parse(JSON.stringify(action.progression));
    return copyProgression;
  }else {
    return state;
  }
}
